import { HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { constants } from 'src/app/config/constant';
import { KeyboardService } from 'src/app/core/common/keyboard/keyboard.service';
import { Country } from 'src/app/core/model/api';
import { ApiHttpService } from 'src/app/core/services/apihttp.service';
import { LogService } from 'src/app/core/services/log.service';
import { MobileTopupService } from 'src/app/core/services/mobile-topup.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { TraceService } from 'src/app/core/services/trace.service';
import { UiService } from 'src/app/core/services/ui.service';
import { WesternUnionService } from 'src/app/core/services/western-union.service';
import { z } from 'zod';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss'],
})
export class CountryComponent implements OnInit, OnDestroy {
  countries: Awaited<ReturnType<typeof this.http.getCountries>> = [];
  filteredCountries: typeof this.countries = []
  destroy$ = new Subject<void>()
  constructor(
    private http: ApiHttpService,
    private config: constants,
    public keyboard: KeyboardService,
    public viewContainerRef: ViewContainerRef,
    public ui: UiService,
    public storage: StorageService,
    public wuService: WesternUnionService
  ) { }

  async ngOnInit(): Promise<void> {
    this.countries = await this.http.getCountries()
    this.filteredCountries = [...this.countries]
    this.keyboard.getInstance()?.onInput$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.searchCountry(value);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  searchCountry(val: string) {
    this.filteredCountries = this.countries.filter((country) => {
      return val == "" || country.name.toLowerCase().includes(val.toLowerCase());
    });
  }

  select_country(country: (typeof this.filteredCountries)[number]) {
    this.storage.set('ui.option', { key: 'country', value: country });
    this.ui.option$.next('')
  }
}
